import { getFileNameWithExtension, Optional } from "sprint-common-web";

import { GetCloudFileListResponseItem } from "../../../../common/api/master-api/cloud-files/get-list/GetCloudFileListResponse";
import { DeliveryType } from "../../../../common/types/DeliveryType";
import { RecordType } from "../../../../common/types/RecordType";
import { CloudFileStatus, mapToCloudFileStatus } from "../../common/types/CloudFileStatus";
import { CloudFileStatusDetails } from "../../common/types/CloudFileStatusDetails";

export interface CloudFileListingItem {
    id: string;
    deliveryId: string;
    filePath: string;
    deliveryFileName: string;
    arrivalDate: string;
    updateDate: string;
    deliveryRef: string;
    originator: string;
    deliveryType?: string;
    status: CloudFileStatus;
    statusDetails?: CloudFileStatusDetails;
    recordType: RecordType;
    isModified?: boolean;
    isDisabled: boolean;
    executionArn?: string;
    isNotificationApproved?: boolean;
    fileRecordId?: string;
    lastUpdatedBy?: string;
}

export const mapToCloudFileListingItem = (item: GetCloudFileListResponseItem): CloudFileListingItem => ({
    id: item.cloudFileId,
    deliveryId: item.deliveryId,
    deliveryRef: item.deliveryRef,
    deliveryFileName: getFileNameWithExtension(item.deliveryFile.path),
    isNotificationApproved: item.isNotificationApproved,
    filePath: item.file.path,
    arrivalDate: item.arrivalDate,
    updateDate: item.updateDate,
    originator: item.originator,
    status: mapToCloudFileStatus(item.status),
    recordType: item.recordType,
    statusDetails: mapToStatusDetails(item.statusDetails),
    deliveryType: DeliveryType[item.deliveryType],
    executionArn: undefined,
    isDisabled: isItemDisabled(item),
    fileRecordId: item.fileRecordId,
    lastUpdatedBy: item.lastUpdatedBy
});

export const isItemDisabled = (item: GetCloudFileListResponseItem): boolean => {
    const cloudFileStatus = mapToCloudFileStatus(item.status);

    return cloudFileStatus === CloudFileStatus.PrepQcFailed || cloudFileStatus === CloudFileStatus.PrepForQc;
};

const mapToStatusDetails = (statusDetails?: CloudFileStatusDetails): Optional<CloudFileStatusDetails> => {
    if (statusDetails && Object.keys(statusDetails).length === 0) {
        return undefined;
    }

    return statusDetails;
};
